import { useTranslation } from 'react-i18next'
import {
  eleventh,
  fourteenth,
  sixteenth,
  // TBC,
  thirteenth,
  twelfth,
  twentieth,
} from '../../data/cities'
import CityOG from './CityOG'

export function Cities() {
  const { t } = useTranslation()
  return (
    <>
      {/* MOBILE TBC */}
      {/* <div className='py-10 md:hidden'>
        <h3 className='text-4xl md:text-5xl font-medium mb-8 underline'>{t('home.scheduleTBC')}</h3>
        <ul className='space-y-4 opacity-90 text-center text-2xl'>
          {TBC.map((city) => (
            // <City key={city} city={city} />
            <CityOG key={city} city={city} />
          ))}
        </ul>
      </div> */}

      {/* DEC 11 */}
      <div className='py-10 w-full grid grid-cols-1 md:grid-cols-2 gap-10 justify-center mb-10'>
        <div className='flex flex-col items-center gap-8'>
          <h3 className='text-4xl md:text-5xl font-medium mb-8 underline'>
            {t('home.schedule11')} {t('home.december')}
          </h3>
          <ul className='space-y-4 opacity-90 text-center text-2xl'>
            {eleventh.map((city) => (
              // <City key={city} city={city} />
              <CityOG key={city} city={city} />
            ))}
          </ul>
        </div>
        {/* DEC 11 */}
        <div className='flex flex-col items-center gap-8'>
          <h3 className='text-4xl md:text-5xl font-medium mb-8 underline'>
            {t('home.schedule12')} {t('home.december')}
          </h3>
          <ul className='space-y-4 opacity-90 text-center text-2xl'>
            {twelfth.map((city) => (
              // <City key={city} city={city} />
              <CityOG key={city} city={city} />
            ))}
          </ul>
        </div>
      </div>

      {/* DEC 13 + 14 GRID */}
      <div className='w-full grid grid-cols-1 md:grid-cols-2 gap-10 gap-y-20 justify-center mb-10'>
        {[
          {
            title: 'home.schedule13',
            cities: thirteenth,
          },
          {
            title: 'home.schedule14',
            cities: fourteenth,
          },
          { title: 'home.schedule16', cities: sixteenth },
          { title: 'home.schedule20', cities: twentieth },
        ].map((group, i) => (
          <div key={i} className='flex flex-col items-center gap-8'>
            <h3 className='text-4xl md:text-5xl font-medium underline'>
              {t(group.title)} {t('home.december')}
            </h3>
            <ul className='space-y-4 opacity-90 text-center text-2xl'>
              {group.cities.map((city) => (
                // <City key={city} city={city} />
                <CityOG key={city} city={city} />
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* DEC 16 */}
      {/* <div className='mb-10'>
        <h3 className='text-4xl md:text-5xl font-medium mb-8 underline'>
          {t('home.schedule16')} {t('home.december')}
        </h3>
        <ul className='space-y-4 opacity-90 text-center text-2xl'>
          {sixteenth.map((city) => (
            // <City key={city} city={city} />
            <CityOG key={city} city={city} />
          ))}
        </ul>
      </div> */}

      {/* DESKTOP TBC */}
      {/* <div className='mb-10 hidden md:block'>
        <h3 className='text-3xl md:text-4xl font-medium mb-8 underline'>{t('home.scheduleTBC')}</h3>
        <ul className='space-y-4 opacity-90 text-center text-2xl'>
          {TBC.map((city) => (
            // <City key={city} city={city} />
            <CityOG key={city} city={city} />
          ))}
        </ul>
      </div> */}
    </>
  )
}
